import React, { useEffect, useRef, useState } from 'react';
import { privateFetch } from '../../../../utils/apiHelper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { CONSTANT } from '../../../../utils/constants';
import { applyCurrencyFormat } from '../../../../utils/datatableHelper';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import styles from "../../../../components/Display/Wrapper.module.scss";

function ProspectPage({ isActive }) {
  const { accountContext } = useAccountContext();
  const exportRef = useRef(null);

  const [prospectData, setProspectData] = useState({});
  const fetchProspectList = async () => {
    await privateFetch('GET', 'gensdemer', `/cu/${accountContext.id}/prospect/`).then((res) => {
      setProspectData(res);
    });
  };

  useEffect(() => {
    fetchProspectList();
  }, []);

  const downloadData = {
    onClick: () => exportRef.current.exportCSV(),
    label: 'Exporter les données',
    icon: 'pi-download'
  };

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer="Totaux" />
        <Column footer={`${prospectData?.total_prospect} soutiens`} />
        <Column />
        <Column />
        <Column footer={`${applyCurrencyFormat(prospectData?.total_amount)}`} />

        <Column />
        <Column />
        <Column />
        <Column />
      </Row>
    </ColumnGroup>
  );

  const typeBodyTemplate = (prospect) => {
    return <span>{CONSTANT.gensdemer.type[prospect.type]}</span>;
  };

  const refundDelayBodyTemplate = (prospect) => {
    return <span>{CONSTANT.gensdemer.refund_delay[prospect.refund_delay]}</span>;
  };

  const amountBodyTemplate = (prospect) => {
    return <span>{applyCurrencyFormat(prospect.amount)}</span>;
  };

  const creationDateBodyTemplate = (prospect) => {
    return <span>{moment(prospect.creation_date).format('DD/MM/YYYY')}</span>;
  };

  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper label="Soutiens" actions={[downloadData]}>
        <div className={styles.pageContentContainer} style={{ paddingBottom: 0 }}>

          <DataTable
            ref={exportRef}
            emptyMessage={'Pas de soutiens à afficher'}
            csvSeparator=";"
            value={prospectData.items}
            scrollable
            size="small"
            scrollHeight="82vh"
            exportFilename={`export_soutiens_${moment().format('DD/MM/YYYY')}`}
            footerColumnGroup={footerGroup}>
            <Column field="first_name" header="Prénom"></Column>
            <Column field="name" header="Nom"></Column>
            <Column field="email" header="Email"></Column>
            <Column field="phone" header="Téléphone"></Column>
            <Column field="amount" header="Montant" body={amountBodyTemplate}></Column>
            <Column field="type" header="Type" body={typeBodyTemplate}></Column>
            <Column
              field="refund_delay"
              header="Délai de remboursement"
              body={refundDelayBodyTemplate}></Column>
            <Column field="message" header="Message"></Column>
            <Column field="creation_date" header="Date" body={creationDateBodyTemplate}></Column>
          </DataTable>
        </div>

      </PageWrapper>
    </div>
  );
}

export default ProspectPage;
